import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

const landlordInsurance: AppContent['landlordInsurance'] = {
  metaContent: {
    title: MetaContentValues.landlordInsurance.title,
  },
  backLabel: 'Back to Landlord support',
  title: 'Landlord insurance',
  ifYouHaveAMortgage:
    'If you have a mortgage on your rental property, you must take out landlord buildings insurance.',
  mightAlsoNeed: {
    title: 'You might also need:',
    listItems: [
      'Rent guarantee insurance.',
      'Unoccupied property cover.',
      'Landlord contents insurance.',
      'Rental income protection.',
      'Landlord emergency cover.',
      'Landlord legal expense cover.',
      "Property owners' liability insurance.",
    ],
  },
};

export default landlordInsurance;
